import { BookingWidget } from "@/components/BookingWidget";
import { Card, CardContent } from "@/components/ui/card";
import { SEOHead } from "@/components/SEOHead";

const Booking = () => {
  return (
    <div className="min-h-screen bg-background pt-32 pb-24 px-3 sm:px-6">
      <SEOHead
        title="Book Your Strategy Call"
        description="Let's discuss how we can build your growth engine. Choose a time below that works for you."
        canonical="/booking"
      />
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-black tracking-tighter mb-6">
            Book Your <span className="text-primary">Strategy Call</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Let's discuss how we can build your growth engine. Choose a time below that works for you.
          </p>
        </div>

        <Card className="border-border/50 shadow-2xl bg-background/50 backdrop-blur-xl overflow-hidden">
          <CardContent className="p-3 sm:p-8 md:p-12">
            <BookingWidget />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Booking;
